import React, { useState, useEffect } from 'react'
// import './login.css'
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import {  useNavigate } from 'react-router-dom';
 import logo from "../../assests/logo.png"
import { handleApi } from "../../utils/authentication"
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {toast} from "react-toastify"


const ClientForgetPassword = () => {
  const [isLoading,setIsLoading]=useState(false)
  const [userDetails,setUserDeatils]=useState({})
  const [sentLinkCount,setSentLinkCount]=useState(0)
  const [showSuccessMessage,setShowSuccessMessage]=useState(false)
  const [showPassword,setShowPassword]=useState(false)
  const [showConfirmPassword,setShowConfirmPassword]=useState(false)
  const params=useParams()
  const navigate=useNavigate()
  //console.log(params)

   const setUpNewPassword=async ()=>{
    try {
        setIsLoading(true)
          let method = "POST"
          let data = JSON.stringify({
            email:formik.values.email,
            user_id:userDetails?.user_id,
            password:formik.values.password
           
           
          })
          let headers = {
            "Content-Type": "application/json",
            "token":userDetails?.token
          }
          let result = await handleApi('user_forget_password', method, headers, data)
  
          if (result?.success) {
            toast.success('Password Reset Successful', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              navigate('/client/login',{state:{email:formik.values.email}})
              
            
        
          }
          else {
            toast.error('Failed to initiate forget password', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }); }
         }
      catch (e) {
        console.log(e)
  
      }finally{
        setIsLoading(false)
      }

   }




  const decryptForgetPasswordData=async ()=>{
    try {
        setIsLoading(true)
   
          let method = "POST"
          let data = JSON.stringify({
            encryptedData:params?.forget_password_token
            })
          let headers = {
            "Content-Type": "application/json"
          }
          let result = await handleApi('user_decrypt_forget_password_data', method, headers, data)
  
          if (result?.success) {
            setUserDeatils({
                email:result?.data?.email,
                user_id:result?.data?.user_id,
                token:result?.token
            })
            formik.setFieldValue('email',result?.data?.email) 
          
          }
          else {
            toast.error(result?.error?.error_message?result?.error?.error_message:'Failed to get user data', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
   }
        
  
      }
      catch (e) {
        console.log(e)
  
      }finally{
        setIsLoading(false)
      }

  }


  const handleForgetPassword=async ()=>{
    try {
        setIsLoading(true)
          let method = "POST"
          let data = JSON.stringify({
            email:formik.values.email,
            user_forget_password_link_prefix:process.env.REACT_APP_URL+'client/forget_password/'
           
          })
          let headers = {
            "Content-Type": "application/json"
          }
          let result = await handleApi('initiate_forget_password', method, headers, data)
  
          if (result?.success) {
            // toast.success('Password reset link sent successfully', {
            //     position: "top-right",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     theme: "light",
            //   }); 
            
              setSentLinkCount((prev)=>prev+1)
              setShowSuccessMessage(true)
              setTimeout(()=>{
                setShowSuccessMessage(false)
              },3000)
          }
          else {
            toast.error('Failed to initiate forget password', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }); }
         }
      catch (e) {
        console.log(e)
  
      }finally{
        setIsLoading(false)
      }
  }

     //formik validtion 
     let validationSchema={}
     let initialValues={}
     if(params?.forget_password_token)
     {
        validationSchema = Yup.object({
            email: Yup.string().email('Invalid email address').required('Email is Required'),
            password: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .max(16, 'Password must be 16 characters or less')
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
              'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
            )
            .required('Password is Required'),
            confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Password does not match').min(8, 'Password must be at least 8 characters').max(16, 'Password must be 16 characters or less').required('Confirm Password')
          
           
          });
          initialValues={
            email:'',
            password:'',
            confirm_password:''
          }

     }
     else{
        validationSchema = Yup.object({
            email: Yup.string().email('Invalid email address').required('Email is Required'),
           
          });
          initialValues={
            email:'',
         
          }


     }

 
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
     if(!params?.forget_password_token)
     {
        handleForgetPassword()
      }
      else{
        setUpNewPassword()

      }
    


    },
  });
  useEffect(()=>{
    if(params?.forget_password_token)
    {
        decryptForgetPasswordData()

    }

  },[])


  


  return (
    <form onSubmit={formik.handleSubmit} className='login_main'>
      <div className="d-flex gap-2  mb-4">
        <img src={logo} alt="" className="" style={{ width: '3rem', height: 'auto' }} />
        <div className={` logo_heading  d-flex justify-content-center flex-column `} >
          <p style={{ fontSize: '1.2rem', lineHeight: "1rem" }} className="mb-0">University </p>
          <p style={{ fontSize: '1.2rem', lineHeight: "1rem" }} className="mb-0">Intelligence</p>
        </div>
      </div>

      <div id="login_card" className="mb-5" style={{  minHeight:'36vh'}}>

        <div className="login_container">

        {showSuccessMessage && <div className="alert alert-success" role="alert">
         <span>Password reset link sent successfully</span> 
          </div>}
        
        <p id="login_heading"><span>Forget Password</span></p>
        {!params?.forget_password_token &&
        <div className='text-center '>
        <span className=''>Please enter your registered Email-ID</span>
        </div>}

   
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email"
              className="form-control input"
              id="email"
              placeholder="Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
             

            />
            {formik.touched.email && formik.errors.email ? (
              <div className='text-danger'>{formik.errors.email}</div>
            ) : null}
          </div>
          {params?.forget_password_token &&
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            {/* <input 
              type="password"
              className="form-control input"
              id="password"
              placeholder="Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
             

            /> */}
            <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control input"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                id="password"
                placeholder="Password"
              />
              <span
                className=" eye_btn "
                onClick={() => {
                  setShowPassword((prev) => !prev);
                }}
              >
                {!showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
           {formik.touched.password && formik.errors.password ? (
              <div className='text-danger'>{formik.errors.password}</div>
            ) : null}
          </div>}
          {params?.forget_password_token &&
          <div className="mb-3">
            <label htmlFor="confirm_password" className="form-label">Confirm Password</label>
            {/* <input 
               type="text"
              className="form-control input"
              id="confirm_password"
              placeholder="Confirm Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.confirm_password}
             

            /> */}
              <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control input"
                id="confirm_password"
                placeholder="Confirm Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirm_password}
              />
              <span
                className=" eye_btn "
                onClick={() => {
                  setShowConfirmPassword((prev) => !prev);
                }}
              >
                {!showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>


            {formik.touched.confirm_password && formik.errors.confirm_password ? (
              <div className='text-danger'>{formik.errors.confirm_password}</div>
            ) : null}
          </div>}
          
          {!params?.forget_password_token ?
     
            <button type="submit" disabled={isLoading} className="btn btn-dark  w-100 login_btn d-flex justify-content-center align-items-center gap-2" >
             {isLoading ?"Sending...":`${sentLinkCount>0?"Resend":"Send"} Password Reset Link`} 
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg></button> :
                <button type="submit" disabled={isLoading} className="btn btn-dark  w-100 login_btn d-flex justify-content-center align-items-center gap-2" >
                {isLoading ?"Processing...":"Reset Password"} 
                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                 <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
               </svg></button>}
          
       


        </div>





      </div>

    </form>



  )
}

export default ClientForgetPassword